import { schema } from "normalizr";

const locationSchema = new schema.Entity("location", {}, { idAttribute: "id" });

const locationListSchema = new schema.Array(locationSchema);

export { locationSchema, locationListSchema };
